import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import './index.css';
import App from './App';

// Configure Amplify with ONLY the modern Auth.Cognito block, minus the
// identity pool. Two independent traps in the generated aws-exports.js:
//
// 1. The legacy (aws_*) section is missing aws_user_pools_web_client_id, and
//    v6's configure() sees aws_project_region, takes the legacy parse path,
//    and ignores the modern "Auth" section — so the user-pool CLIENT was
//    never configured and every sign-in/session read failed silently.
// 2. The identity pool's IAM roles carry Amplify's default Deny trust policy,
//    so any credential exchange throws InvalidIdentityPoolConfigurationException
//    and rejects fetchAuthSession. The app authenticates purely with the
//    user-pool idToken (API Gateway COGNITO_USER_POOLS authorizer) and never
//    needs AWS credentials, so the pool is omitted.
//
// aws-exports.js is Amplify-generated (edits there are lost on push), so the
// reshaping lives here in app code. API/Storage config is unused (axios + no
// Storage SDK).
const { identityPoolId: _unusedIdentityPool, ...cognitoAuth } = awsconfig.Auth.Cognito;
Amplify.configure({ Auth: { Cognito: cognitoAuth } });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 120_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
